import { GradientTitle } from '../ui/typography/GradientTitle';
import { LucideIcon } from 'lucide-react';

interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
  icon?: LucideIcon;
  useH1?: boolean;
}

export const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, children, icon: Icon, useH1 = true }) => {
  return (
    <div className="container mx-auto px-6 py-12">
      <GradientTitle className="text-3xl md:text-4xl mb-8 text-center flex items-center justify-center gap-3" useH1={useH1}>
        {Icon && <Icon className="w-8 h-8 text-orange-500" />}
        {title}
      </GradientTitle>
      
      <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-lg border border-gray-100 p-8 max-w-5xl mx-auto">
        {children}
      </div>
    </div>
  );
}; 